"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./CustomInput.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _FormField = _interopRequireDefault(require("../../mixins/FormField"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var CustomInput = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomInput, _React$Component);

  var _super = _createSuper(CustomInput);

  function CustomInput() {
    _classCallCheck(this, CustomInput);

    return _super.apply(this, arguments);
  }

  _createClass(CustomInput, [{
    key: "handleEnter",
    value: function handleEnter(e) {
      if (e.key === "Enter") {
        this.value = this.inputElement.value;
        this.updateBackingValue(true);

        if (!(0, _isUndefined.default)(this.props.onBlur)) {
          this.props.onBlur(e);
        } else {
          this.inputElement.select();
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange() {
      this.dirty = true;
      this.handleChange();
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      // Warning: The JavaScript blur action (not our function here, but JavaScript's
      // built-in blur) does not behave the same way on mobile as it does on desktop.
      this.handleBlur(e); // Used if you want to trigger an action on blur ONLY if there are changes to the underlying model.

      if (this.dirty && this.props.handleBlurPostAction) {
        this.props.handleBlurPostAction();
        this.dirty = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fieldName = _this$props.fieldName,
          label = _this$props.label,
          type = _this$props.type,
          id = _this$props.id,
          name = _this$props.name,
          inputDisabled = _this$props.inputDisabled,
          skipBlur = _this$props.skipBlur,
          autoComplete = _this$props.autoComplete;
      var blur = skipBlur ? function () {
        return;
      } : this.onBlur;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames("custom-input")
      }, !(0, _isEmpty.default)(label) && /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: fieldName
      }, label), /*#__PURE__*/_react.default.createElement("input", _extends({
        type: type,
        id: id || fieldName,
        name: name || fieldName,
        ref: this.setInputRef,
        value: this.readValue(),
        onChange: this.onChange,
        onBlur: blur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleEnter
      }, this.getInnerInputProps(), {
        disabled: inputDisabled,
        autoComplete: type === "password" ? "off" : autoComplete
      })), this.renderErrors());
    }
  }]);

  return CustomInput;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  label: _propTypes.default.node,
  type: _propTypes.default.oneOf(["text", "number", "email", "tel", "date", "datetime", "month", "search", "password"])
}), _defineProperty(_class2, "defaultProps", {
  type: "text"
}), _class2), (_applyDecoratedDescriptor(_class.prototype, "handleEnter", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBlur", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "onBlur"), _class.prototype)), _class); // FormField makes this an observer

var _default = (0, _FormField.default)(CustomInput);

exports.default = _default;